import React, { useContext, useEffect, useState } from 'react'
import { Button, Dropdown, Notification, Progress, toast } from 'components/ui'
import { CompanyContext } from 'contexts/CompanyContext'
import { HiOutlineChevronDown, HiOutlineChip, HiOutlineLightningBolt, HiOutlinePlusCircle, HiOutlineSparkles } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { formatNumber } from 'utils/formatNumber';
import { BsCheckCircleFill, BsCircle, BsLayers } from 'react-icons/bs';
import { MdLayers } from 'react-icons/md';
import { HiOutlineSquare2Stack, HiOutlineSquare3Stack3D, HiOutlineUser, HiPlus } from 'react-icons/hi2';
import { PriorityModalContext } from 'contexts/PriorityModalContext';
import { api as Api } from 'api/http';
import { SessionContext } from 'contexts/SessionContext';
import { Loading } from 'components/shared';
import { HiOutlineUserPlus } from 'react-icons/hi2';
import CardDialog from 'views/subscription/CardDialog';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';

const OutOfUsersModal = ({ limit = true }) => {

    const { closeModalPriority } = useContext(PriorityModalContext);
    const { user, updateUserData } = useContext(SessionContext);

    const [productActive, setProductActive] = useState();
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [cardDialogOpened, setCardDialogOpened] = useState(false);
    const [subscriptionCreated, setSubscriptionCreated] = useState(false);

    const stripe = useStripe();
    const elements = useElements();

    const recurring = user?.subscription?.items?.[0]?.price?.recurring || "month";

    const icons = [
        // <HiOutlineUserPlus className='text-white text-sm' />
    ]

    const handleOnNext = () => {
        if (!user?.pm_last_four || !user?.subscription?.id) {
            setCardDialogOpened(true);
        } else {
            updateSubscription();
        }
    }

    const updateSubscription = () => {
        let newProductPriceId = products?.filter(e => e.id == productActive)?.[0]?.prices?.filter(e => e.recurring == recurring)?.[0]?.id;
        let newSubscription = user?.subscription?.items?.map((item) => {
            return {
                "id": item.price.id,
                "quantity": item.quantity
            }
        });
        if (newSubscription?.filter(item => item.id == newProductPriceId)?.length == 0) {
            newSubscription.push({
                "id": newProductPriceId,
                "quantity": 1
            });
        } else {
            newSubscription = newSubscription.map((item) => {
                if (item.id == newProductPriceId) {
                    item.quantity += 1;
                }
                return item;
            })
        }
        
        setIsSubmitting(true);
        Api.put(`/subscriptions`, {}, { prices: newSubscription }).then((response) => {
            toast.push(<Notification title="Great, plan has been upgraded! You can keep inviting!" type="success" />, { placement: "top-center" });
            updateUserData();
            setIsSubmitting(false);
            closeModalPriority();
        }).catch((err) => {
            toast.push(<Notification title="An error ocurred. Please, try again later." type="danger" />, { placement: "top-center" });
        }).finally(() => {
            setIsSubmitting(false);
        });
    }

    const handleSubmitStripe = async (event) => {
        event && event.preventDefault();
        
        setIsSubmitting(true);
        
        const newProductPriceId = products?.filter(e => e.id == productActive)?.[0]?.prices?.filter(e => e.recurring == recurring)?.[0]?.id;
        let newSubscription = user?.subscription?.items?.map((item) => {
            return {
                "id": item.price.id,
                "quantity": item.quantity
            }
        });
        
        if (newSubscription?.filter(item => item.id == newProductPriceId)?.length == 0) {
            newSubscription.push({
                "id": newProductPriceId,
                "quantity": 1
            });
        } else {
            newSubscription = newSubscription.map((item) => {
                if (item.id == newProductPriceId) {
                    item.quantity += 1;
                }
                return item;
            })
        }

        let _paymentMethod;
        if (!user?.pm_last_four || !user?.subscription?.id) {
            const {error, paymentMethod} = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
            });
            if (error) {
                setIsSubmitting(false);
                toast.push(<Notification title={error.message} type="warning" />, { placement: 'top-center' });
                return;
            }
            _paymentMethod = paymentMethod;
        }

        const data = {
            payment_method_id: _paymentMethod?.id || undefined,
            prices: newSubscription
        };

        Api.put(`/subscriptions`, {}, data).then((response) => {
            setSubscriptionCreated(true);
            setTimeout(() => {
                updateUserData();
                toast.push(<Notification title="Great, plan has been upgraded! You can keep inviting!" type="success" />, { placement: "top-center" });
                setIsSubmitting(false);
                closeModalPriority();
            }, 2000);
        }).catch((err) => {
            toast.push(<Notification title={err?.message || 'An error occurred. Please, try again later'} type="danger" />, { placement: 'top-center' });
        }).finally(() => {
            setIsSubmitting(false);
        });
    }

    useEffect(() => {
        setIsLoading(true);
        Api.get(`/products?include=prices&filter[type]=add-on`).then(({ data: _products }) => {
            const filteredProducts = _products.filter(item => item.name.includes("user")).map((item, key) => { return { ...item, icon: icons[key] } });
            setProducts(filteredProducts);
            setProductActive(filteredProducts?.[0]?.id);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    return (
        <>
            <div className='flex flex-col'>
                {/* Enhanced Header */}
                <div className="relative mb-6 p-6 -m-6 -mt-6 bg-gradient-to-br from-emerald-50/80 to-teal-50/60 dark:from-emerald-900/20 dark:to-teal-900/20 border-b border-emerald-200/30 dark:border-emerald-700/30">
                    <div className="flex items-center gap-4">
                        <div className="flex-shrink-0 p-3 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 shadow-lg shadow-emerald-500/25">
                            <HiOutlineUserPlus className="w-6 h-6 text-white" />
                        </div>
                        <div className="flex-1 min-w-0">
                            {limit 
                                ? <>
                                    <h3 className='text-xl font-bold text-gray-900 dark:text-gray-100 mb-0 leading-tight'>
                                        Oops! You've hit your user limit
                                    </h3>
                                    <p className='text-sm text-gray-600 dark:text-gray-300 leading-relaxed'>
                                        Add more users to your plan to keep your team growing!
                                    </p>
                                </>
                                : <>
                                    <h3 className='text-xl font-bold text-gray-900 dark:text-gray-100 mb-0 leading-tight'>
                                        Add Users
                                    </h3>
                                    <p className='text-sm text-gray-600 dark:text-gray-300 leading-relaxed'>
                                        Expand your team with additional user seats!
                                    </p>
                                </>
                            }
                        </div>
                    </div>
                </div>

                {/* Enhanced Product Selection */}
                <div className='flex flex-col gap-3 mb-6'>
                    {isLoading 
                        ? <div className="flex items-center justify-center py-12">
                            <Loading type={`element`} />
                          </div>
                        : <>
                            {products && products.map((item, key) => (
                                <div 
                                    onClick={() => setProductActive(item?.id)} 
                                    key={key} 
                                    className={`group cursor-pointer relative overflow-hidden rounded-2xl border transition-all duration-300 hover:shadow-lg hover:scale-[1.02] ${
                                        productActive == item?.id 
                                            ? 'bg-gradient-to-r from-emerald-50/80 to-teal-50/60 dark:from-emerald-900/30 dark:to-teal-900/30 border-2 border-emerald-500 dark:border-emerald-400 shadow-lg shadow-emerald-500/20' 
                                            : 'bg-white/60 dark:bg-gray-800/60 border-gray-200 dark:border-gray-600 hover:bg-gray-50/80 dark:hover:bg-gray-700/60 hover:border-gray-300 dark:hover:border-gray-500'
                                    }`}
                                >
                                    <div className='flex justify-between items-center p-5'>
                                        <div className='flex items-center gap-4'>
                                            <div className={`relative p-3 rounded-xl transition-all duration-300 ${
                                                productActive == item?.id 
                                                    ? 'bg-gradient-to-br from-emerald-500 to-teal-600 shadow-lg shadow-emerald-500/30' 
                                                    : 'bg-gradient-to-br from-gray-400 to-gray-500 group-hover:from-emerald-400 group-hover:to-teal-500'
                                            }`}>
                                                {item?.icon}
                                            </div>
                                            <div className='flex flex-col gap-1'>
                                                <div className='font-bold text-base text-gray-800 dark:text-gray-100'>
                                                    {formatNumber(item?.users_amount, 0)} User{item?.users_amount > 1 && `s`}
                                                </div>
                                                <div className='text-sm text-gray-600 dark:text-gray-400 font-medium'>
                                                    +${formatNumber(item?.prices?.filter(e => e.recurring == recurring)?.[0].amount / (recurring == "year" ? 12 : 1) / 100, 0)}/month
                                                </div>
                                            </div>
                                        </div>
                                        <div className='text-2xl transition-all duration-300'>
                                            {productActive == item?.id
                                                ? <BsCheckCircleFill className='text-emerald-500 animate-pulse' />
                                                : <BsCircle className='text-gray-300 dark:text-gray-600 group-hover:text-emerald-400' />
                                            }
                                        </div>
                                    </div>
                                    
                                    {/* Selection indicator */}
                                    {productActive == item?.id && (
                                        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-500 to-teal-600"></div>
                                    )}
                                </div>
                            ))}
                        </>
                    }
                </div>

                {/* Enhanced Action Buttons */}
                <div className='flex justify-end gap-3 pt-2'>
                    <Button 
                        onClick={closeModalPriority}
                        className="px-6 py-2.5 text-sm font-medium"
                    >
                        Cancel
                    </Button>
                    <Button 
                        loading={isSubmitting} 
                        disabled={!productActive || isLoading} 
                        variant="solid" 
                        type="button" 
                        onClick={handleOnNext}
                        className="px-6 py-2.5 text-sm font-medium bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 shadow-lg shadow-emerald-500/30 transition-all duration-300"
                        icon={<HiOutlineSparkles className="text-sm" />}
                    >
                        {isSubmitting ? 'Processing...' : 'Add User'}
                    </Button>
                </div>
            </div>
            
            <CardDialog 
                cardDialogOpened={cardDialogOpened} 
                setCardDialogOpened={setCardDialogOpened} 
                handleSubmitStripe={handleSubmitStripe} 
                isSubmittingCard={isSubmitting}
                subscriptionCreated={subscriptionCreated}
            />
        </>
    )
}

export default OutOfUsersModal
